import React, { useEffect, useState } from "react";
import { getImageUrl } from "../services/api";
import "./About.css";

const About = () => {
  const [bannerUrl, setBannerUrl] = useState("");

  useEffect(() => {
    setBannerUrl(getImageUrl("about-banner"));
  }, []);

  return (
    <div className="about-page">
      <section className="about-hero" style={{ backgroundImage: bannerUrl ? `url(${bannerUrl})` : 'none' }}>
        <h1>À propos de nous</h1>
        <p>Le style de ceux qui n’ont pas peur de leurs faiblesses</p>
      </section>

      <div className="container">
        <section className="about-story">
          <div className="story-content">
            <h2>Notre Histoire</h2>
            <p>
              <b>PR</b>, ce n’est pas une histoire de records.<br />
              C’est une histoire de regrets...
            </p>
            <p>
              On est deux frères, tous les deux passionnés de <b>CrossFit</b>.
              L’un est <b>coach</b> : il parle technique, progression, intensité.<br />
              L’autre est <b>directeur artistique</b> : il parle visuel, messages, impact.<br />
              Ensemble, on parle surtout d’une chose que tout le monde connaît… mais que peu assument : les <b>faiblesses</b>
            </p>
            <p>
              <b>PR</b> signifie <b>Personal Regrets</b>.<br />
              Parce qu’au <b>CrossFit</b>, derrière chaque PR glorieux, il y a surtout des WOD mal gérés, des départs trop rapides, des time
              caps ratés et des moments où le mental lâche bien avant le corps.
            </p>
            <p>
              L’idée de la marque est simple :<br />
              Créer des vêtements au <b>design soigné</b>, presque sérieux…<br />
              Puis te faire <b>sourire</b> quand tu lis le message, parce que tu te reconnais immédiatement.
            </p>
            <p>
             Ce ne sont pas des punchlines. Ce sont des vérités.
            </p>
            <p>
              <b>PR</b> s’adresse à tous ceux qui aiment s’entraîner, se dépasser… mais surtout en rire.<br />
              À ceux qui savent que la performance, c’est important, mais que l’<b>autodérision</b> l’est encore plus.
            </p>
            <p>
              Ici, on ne glorifie pas l’échec.<br />
              On le porte fièrement.
            </p>
            <p>
              Bienvenue chez <b>PR</b>.<br />
              <i>Porte fièrement tes faiblesses</i>
            </p>
          </div>
        </section>

        <section className="about-values">
          <h2 className="section-title">Nos Valeurs</h2>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">🎨</div>
              <h3>Design</h3>
              <p>
                Des visuels forts, propres et identitaires.
                Beaux au premier regard, ironiques au second
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">😂</div>
              <h3>Humour</h3>
              <p>De l’autodérision, jamais du mépris.</p>
            </div>
            <div className="value-card">
              <div className="value-icon">✅</div>
              <h3>Qualité</h3>
              <p>
                Matières solides, confort. Impression DTF durable. Testées
                pour la box, validées pour le quotidien.
              </p>
            </div>
            <div className="value-card">
              <div className="value-icon">🏋️</div>
              <h3>Communauté</h3>
              <p>
                RX, Scaled, débutant ou compétiteur
                Si tu t’identifies, tu es chez toi.
              </p>
            </div>
          </div>
        </section>

        <section className="about-cta">
          <h2>Rejoignez le mouvement</h2>
          <p>Découvrez notre collection et exprimez votre style sans regret</p>
          <a href="/shop" className="btn btn-primary">
            Voir la collection
          </a>
        </section>
      </div>
    </div>
  );
};

export default About;
